module.exports = __webpack_public_path__ + "static/media/atlas-logo.c4843bf5.png";